// src/store/dashboard.slice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dashboardService } from "../services/dashboard.service";

export const fetchDashboard = createAsyncThunk(
  "dashboard/fetch",
  async (payload, thunkAPI) => {
    try {
      // payload: { shopId?, startDate, endDate, preset }
      return await dashboardService.getDashboard(payload);
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch dashboard");
    }
  }
);

const initialState = {
  dashboard: null,   // l’objet complet renvoyé par l’API
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboardError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard = action.payload || null;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDashboardError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
